/* eslint-disable react-refresh/only-export-components */

import { createContext, useContext } from "react";

import type { AccordionProps } from "../components/molecules/Accordion/Accordion.types";

const AccordionContext = createContext<AccordionProps | null>(null);

export function useAccordionProps() {
  const context = useContext(AccordionContext);
  if (!context) {
    throw new Error("useAccordionProps must be used within an Accordion");
  }
  return context;
}

export default AccordionContext;
